import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DoubleOptInApiService } from './double-opt-in-api-service';

@Component({
  selector: 'app-double-opt-in-confirm',
  standalone: false,
  templateUrl: './double-opt-in-confirm.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './double-opt-in-confirm.component.scss'
})
export class DoubleOptInConfirmComponent implements OnInit {
  talentId: string = this.route.snapshot.queryParams['talentId'];
  talentEmail: string = this.route.snapshot.queryParams['email'];

  constructor(private route: ActivatedRoute, private doubleOptInApi: DoubleOptInApiService) {}

  ngOnInit(): void {
    this.doubleOptInApi.saveDoubleOptInStatus(this.talentId, this.talentEmail).subscribe(
      () => {},
      (error) => {console.log('Could not save Double Opt-In Status: ' + error)}
    );
  }
}
